import { useParams } from "react-router-dom";
import { SidebarCol } from "../../chatMain/Sidebar/Sidebar";
import { MainContentPhysical } from "../maincontent-physical/maincontent-physical";
import "./Physical-Assessment.css";

export const PhysicalDashboard = () => {
  const { domain } = useParams();

  return (
    <div className="physical-dashboard">
      <div className="sidebar-physical">
        <SidebarCol />
      </div>

      <div className="maincontentarea-physical">
        <MainContentPhysical />
      </div>
    </div>
  );
};
